// Native details remain usable without JavaScript. This adds direct case links.
(() => {
  const initialize = (guide) => {
    if (guide.dataset.lifestyleReady) return;
    guide.dataset.lifestyleReady = 'true';
    const cases = [...guide.querySelectorAll('[data-lifestyle-case]')];
    const locate = () => {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      if (!id) return;
      const target = document.getElementById(id);
      if (!target || !guide.contains(target)) return;
      const details = target.matches('[data-lifestyle-case]') ? target.querySelector('details') : null;
      if (details) details.open = true;
      requestAnimationFrame(() => {
        target.focus({ preventScroll: true });
        target.scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    };
    guide.querySelector('[data-lifestyle-controls]').hidden = false;
    guide.querySelector('[data-lifestyle-open]').addEventListener('click', () => {
      cases.forEach((item) => { item.querySelector('details').open = true; });
    });
    guide.querySelector('[data-lifestyle-close]').addEventListener('click', () => {
      cases.forEach((item) => { item.querySelector('details').open = false; });
    });
    guide.querySelectorAll('[data-lifestyle-jump]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        history.pushState(null, '', link.hash);
        locate();
      });
    });
    window.addEventListener('hashchange', locate);
    window.addEventListener('popstate', locate);
    locate();
  };
  document.querySelectorAll('[data-lifestyle-guide]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-lifestyle-guide]').forEach(initialize);
  });
})();
